export default __webpack_public_path__ + "static/splash-7f27706f76c5e71a4e1c5e791de71a82.svg";